import React, { useState } from 'react';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import './TransactionCard.css';

const API = process.env.REACT_APP_API_URL;

function fmt(val) {
  return parseFloat(val || 0).toLocaleString('es-EC', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export default function TransactionCard({ tx, isProducer, onRated }) {
  const { t } = useTranslation();
  const [showRating, setShowRating] = useState(false);
  const [score, setScore] = useState(5);
  const [comment, setComment] = useState('');
  const [saving, setSaving] = useState(false);

  const handleRate = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.post(`${API}/market/transactions/${tx.id}/rate/`, { score, comment });
      setShowRating(false);
      if (onRated) onRated();
    } catch (err) {
      alert(err.response?.data?.error || 'Error');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="tx-card bmp-card">
      <div className="tx-card-header">
        <span className="tx-card-id">TX #{tx.id}</span>
        <span className={`bmp-status bmp-status--${tx.status}`}>{tx.status_display}</span>
      </div>
      <div className="tx-card-details">
        <span>{isProducer ? t('mkt_buyer') : t('mkt_seller')}: <strong>@{isProducer ? tx.buyer_username : tx.producer_username}</strong></span>
        <span><strong>{tx.final_boxes.toLocaleString('es-EC')}</strong> {t('mkt_boxes_label')} @ <strong>${fmt(tx.final_price)}</strong></span>
        <span className="tx-card-total">${fmt(tx.total)}</span>
      </div>
      <div className="tx-card-footer">
        <span className="tx-card-date">{new Date(tx.created_at).toLocaleDateString('es-EC')}</span>
        {tx.my_rating ? (
          <span className="tx-card-rated">{'★'.repeat(tx.my_rating.score)}{'☆'.repeat(5 - tx.my_rating.score)}</span>
        ) : (
          <button className="bmp-btn-ghost tx-rate-btn" onClick={() => setShowRating(v => !v)}>
            &#11088; {t('bmp_rate')}
          </button>
        )}
      </div>

      {showRating && !tx.my_rating && (
        <form className="tx-rating-form" onSubmit={handleRate}>
          <div className="tx-rating-stars">
            {[1, 2, 3, 4, 5].map(s => (
              <button
                key={s}
                type="button"
                className={`tx-star${s <= score ? ' tx-star--active' : ''}`}
                onClick={() => setScore(s)}
              >★</button>
            ))}
          </div>
          <input
            type="text"
            value={comment}
            onChange={e => setComment(e.target.value)}
            placeholder={t('bmp_rating_comment')}
            maxLength={300}
          />
          <button type="submit" className="bmp-btn bmp-btn-primary" disabled={saving}>
            {saving ? t('saving') : t('bmp_submit_rating')}
          </button>
        </form>
      )}
    </div>
  );
}
